import { render, staticRenderFns } from "./RegistrationAddressInformation.vue?vue&type=template&id=58d46e12&scoped=true"
import script from "./RegistrationAddressInformation.vue?vue&type=script&lang=js"
export * from "./RegistrationAddressInformation.vue?vue&type=script&lang=js"
import style0 from "./RegistrationAddressInformation.vue?vue&type=style&index=0&id=58d46e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d46e12",
  null
  
)

export default component.exports